
<template>
    
        <mars-view class="bottom-bar" :class="{'compatible-safarea': compatibleSafarea}"><mars-view class="bottom-bar-icon home-icon" @click.native="handleBackHome"><mars-view class="icon iconfont image-home"></mars-view><mars-view>
            首页
        </mars-view></mars-view><mars-view class="bottom-bar-icon search-ion" @click.native="handleViewExpertlist"><mars-view class="icon iconfont image-home image-search"></mars-view><mars-view>
            找律师
        </mars-view></mars-view><mars-view v-if="serviceButton && serviceButton.call && serviceButton.consult"><mars-view class="bottom-bar-counsel-both"><mars-view v-if="serviceButton && serviceButton.call" class="search search-left" @click.native="tapFn(serviceButton.call, 'bottombar-phone')">{{ serviceButton.call.txt }}
                <login-button v-if="canIUseLoginButton && platform !== 'web' && serviceButton.call.type === 'url' && serviceButton.call.pay_ui !== ''" class="cell-item-login" class-name="cell-item-login" @callBackSucc="tapFn(serviceButton.call, 'bottombar-phone')"></login-button></mars-view><mars-view v-if="serviceButton && serviceButton.consult" class="search search-right" @click.native="tapFn(serviceButton.consult, 'bottombar-online')">{{ serviceButton.consult.txt }}</mars-view></mars-view></mars-view><mars-view v-else :class="{'lightstyle': lightStyle}"><mars-view v-if="serviceButton && serviceButton.call" class="bottom-bar-counsel-single" @click.native="tapFn(serviceButton.call, 'bottombar-phone')"><mars-view>{{ serviceButton.call.txt }}</mars-view><login-button v-if="canIUseLoginButton && platform !== 'web' && serviceButton.call.type === 'url' && serviceButton.call.pay_ui !== ''" class="cell-item-login" class-name="cell-item-login" @callBackSucc="tapFn(serviceButton.call, 'bottombar-phone')"></login-button></mars-view><mars-view v-if="serviceButton && serviceButton.consult && serviceType !== 'showConsult'" class="bottom-bar-counsel-single" @click.native="tapFn(serviceButton.consult, 'bottombar-online')"><mars-view>{{ serviceButton.consult.txt }}</mars-view></mars-view><mars-view v-if="serviceButton && serviceButton.consult && serviceType === 'showConsult'" class="bottom-bar-single-consult" @click.native="tapFn(serviceButton.consult, 'bottombar-online')"><mars-view class="l-font-semibold bottom-bar-single-consult-text">{{ serviceButton.consult.txt }}</mars-view><mars-view v-if="consultCount" class="bottom-bar-single-consult-num">{{ consultCount }}人在咨询</mars-view></mars-view></mars-view><c-popup :show="showPopup" :client-ip="clientIp" :data="curPopupData" @close="tapFn({type: 'popup-close'})"></c-popup><mars-view class="bottom-bar-block"></mars-view></mars-view>
    
</template>

<script>
/* globals getApp, Page, swan */
import { act } from '../../static/utils/navigate.js';
import Popup from "../../components/common/popup.vue";
import loginButton from "../loginButton/index.vue";
import { putCpc } from '../../static/utils/cpcfree.js';
export default {
  components: {
    'c-popup': Popup,
    'login-button': loginButton
  },
  props: {
    serviceButton: {
      type: Object,
      default: () => ({})
    },
    qaInfo: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: Number,
      default: 0
    },
    clientIp: {
      type: String,
      default: ''
    },
    loggerKey: {
      type: String,
      default: ''
    },
    lightStyle: {
      type: Boolean,
      default: false
    },
    // 底部是否需要添加iphoneX底部安全区域
    compatibleSafarea: {
      type: Boolean,
      default: true
    },
    // 用于统计页面来源
    pageFrom: {
      type: String,
      default: ''
    },
    // 咨询按钮 带咨询数量
    serviceType: {
      type: String,
      default: ''
    },
    consultCount: {
      type: String,
      default: ''
    },
    form: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPopup: false,
      curPopupData: {},
      canIUseLoginButton: getApp().globalData.canIUseLoginButton,
      platform: getApp().globalData.platform
    };
  },
  methods: {
    handleBackHome() {
      let logData = `bottombar-home${this.loggerKey ? '-' : ''}${this.loggerKey}`;
      act({
        target: '/pages/home/index',
        type: 'switch',
        log: logData,
        logOption: {
          type: this.type
        }
      });
    },
    handleViewExpertlist() {
      let logData = `bottombar-list${this.loggerKey ? '-' : ''}${this.loggerKey}`;
      act({
        target: `/pages/expertlist/index?expertiseArea=${this.qaInfo && this.qaInfo.qaType || ''}`,
        type: 'url',
        log: logData,
        logOption: {
          type: this.type
        }
      });
    },
    tapFn(data, log) {
      if (this.form === 'experthome') {
        // 来自律师主页的事件直接冒泡上去
        this.$emit('clickCall');
        return;
      }
      const {
        target,
        type,
        feeSrcId,
        resource
      } = data;
      let logData = `${log}${this.loggerKey ? '-' : ''}${this.loggerKey}`;
      if (type === 'url') {
        putCpc({
          target,
          type,
          feeSrcId,
          resource
        }, this, 'common', '-bottomBar').finally(() => {
          act({
            target,
            type,
            log: logData,
            vm: this
          });
        });
      } else {
        act({
          target,
          type,
          log: logData,
          vm: this,
          logOption: {
            type: this.type
          },
          ext: {
            pageFrom: this.pageFrom
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.bottom-bar {
  overflow: hidden;
  background: #fff;
  padding: 9px 14px;
}
.bottom-bar .bottom-bar-icon {
  float: left;
  font-size: 9px;
  text-align: center;
  color: #555;
}
.bottom-bar .home-icon {
  padding-right: 22px;
  padding-left: 6px;
  color: #525252;
}
.bottom-bar .search-ion {
  padding-left: 4px;
  padding-right: 24px;
}
.bottom-bar .image-home {
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 19px;
  background-size: 100% 100%;
  margin: 0 auto;
  color: #1f1f1f;
}
.bottom-bar .image-search {
  font-size: 24px;
}
.bottom-bar .bottom-bar-split {
  float: left;
  width: 1px;
  height: 22px;
  margin-top: 6px;
  background: #979797;
}
.bottom-bar .bottom-bar-counsel {
  float: right;
}
.bottom-bar .bottom-bar-counsel-single {
  float: right;
  width: 218px;
  padding: 11px 0;
  text-align: center;
  font-size: 14px;
  color: white;
  border-radius: 52px;
  background: #445fbb;
  position: relative;
}
.bottom-bar .bottom-bar-single-consult {
  margin-left: 24px;
  height: 40px;
  background: #445fbb;
  border-radius: 66px;
  display: flex;
  color: #fff;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.bottom-bar .bottom-bar-single-consult-num {
  margin-top: 3px;
  font-size: 12px;
  line-height: 12px;
}
.bottom-bar .bottom-bar-single-consult-text {
  font-size: 15px;
  line-height: 15px;
}
.bottom-bar .bottom-bar-counsel-both {
  float: right;
  box-sizing: border-box;
  font-size: 14px;
  color: white;
}
.bottom-bar .bottom-bar-counsel-both .search {
  float: left;
  padding: 11px 0;
  width: 111px;
  text-align: center;
}
.bottom-bar .bottom-bar-counsel-both .search-left {
  padding: 10px 0;
  border: 0.5px solid #445fbb;
  color: #445fbb;
  border-radius: 52px 0 0 52px;
  position: relative;
}
.bottom-bar .bottom-bar-counsel-both .search-right {
  border-radius: 52px;
  border-radius: 0 90px 90px 0;
  background: #445fbb;
}
.bottom-bar .bottom-bar-block {
  height: 9px;
  width: 100%;
  float: left;
}
.bottom-bar .lightstyle .bottom-bar-counsel-single {
  border: 1px solid #445fbb;
  color: #445fbb;
  background: #fff;
}
.compatible-safarea {
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
@media screen and (max-width: 320px) {
  .home-icon,
  [class*="__home-icon"] {
    padding-right: 13px !important;
  }
  .search-ion,
  [class*="__search-ion"] {
    padding-left: 13px !important;
  }
  .bottom-bar-counsel-single,
  [class*="__bottom-bar-counsel-single"] {
    width: 170px !important;
  }
}

</style>
